module.exports = __webpack_public_path__ + "static/d-DLinares-c04a483d89b8815a33a0b01e18d231f3.jpg";